import styled from 'styled-components'
import { Flex, Box, Text } from 'vvs-uikit'
import CardButton from 'views/VvsGotchi/components/CardButton'
import { VvsGotchiActionBaseButton } from 'views/VvsGotchi/components/ActionButton'
import { LightPageContainer } from '../../styles'

const grayoutStyle = ({ grayout }: { grayout?: boolean }) => grayout && 'filter: grayscale(100%);'

export const PageContainer = styled(LightPageContainer)<{ focusOnGame: boolean }>`
  position: relative;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
  ${({ focusOnGame }) =>
    focusOnGame &&
    `
    overflow: hidden;
  `}
`
export const RetroBaseText = styled(Text)`
  font-family: RetroLandMayhem;
`
export const RetroText = styled(RetroBaseText)`
  color: black;
`

export const MoleDashQuestBlockButton = styled(CardButton)<{ grayout?: boolean }>`
  border: 3px solid black;
  align-items: center;
  background-image: url(/images/vvsGotchi/quest/mole_dash_bg.jpg);
  background-size: cover;
  background-position: center;

  ${grayoutStyle}
`

export const MoleDashCanvasContainer = styled(Box)`
  position: absolute;
  width: 100%;
  height: 100%;
`

export const CanvasCoverBox = styled(Box)<{
  bg?: string
  grayout?: boolean
  closed?: boolean
  blockPointerEvents?: boolean
}>`
  position: absolute;
  width: 100%;
  height: 100%;

  background-image: ${({ grayout, bg }) =>
    grayout ? `url('/images/vvsGotchi/bg_gray.png')` : `url('${bg || '/images/vvsGotchi/bg_violet_red.png'}')`};

  pointer-events: ${({ blockPointerEvents }) => (blockPointerEvents ? 'all' : 'none')};
  transition: opacity 500ms;
  opacity: ${({ closed }) => (closed ? 0 : 1)};
`

export const CloseButtonBox = styled(Box)`
  position: absolute;
  top: 12.5px;
  right: 10px;
`

export const TitleBox = styled(Box)<{ focusOnGame: boolean; hidden: boolean; grayout?: boolean }>`
  ${({ hidden }) => hidden && 'display: none;'}
  position: absolute;
  top: ${({ focusOnGame }) => (focusOnGame ? '20px' : '30px')};
  left: 50%;
  width: ${({ focusOnGame }) => (focusOnGame ? '30%' : '50%')};
  transform: translate(-50%, 0);
  transition: top 500ms, width 500ms;

  ${grayoutStyle}
`

export const GameEntryFlex = styled(Flex)<{ focusOnGame: boolean }>`
  flex-direction: column;
  position: absolute;
  top: 150px;
  left: 22.5%;
  right: 22.5%;

  transition: top 1000ms;
  ${({ focusOnGame }) =>
    focusOnGame &&
    `
    top: 100%;
  `}
`
export const GameInfoFlex = styled(Flex)<{ bg?: string }>`
  background: ${({ bg, theme }) => (bg ? `url(${bg})` : theme.colors.paleYellow)};
  background-size: cover;
  background-position: center;
  border: 4px solid black;
  border-bottom: none;
  border-radius: 12px 12px 0 0;
  padding: 8px 12px;
`
export const BestRecordText = styled(RetroText)`
  background: ${({ theme }) => theme.colors.warningLight};
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 10px;
`
export const GameInfoActionButton = styled(VvsGotchiActionBaseButton)`
  border-radius: 0 0 12px 12px;
  font-size: 16px;
  transition: font-size 0.25s;

  ${({ disabled, theme }) =>
    disabled
      ? `
    color: ${theme.colors.darkGrey};
  `
      : `
    &:hover, &:focus {
      font-size: 17px;
    }
    &:active {
      font-size: 15px;
    }
  `}

  &:focus {
    outline: none;
  }
`

export const GameOverFlex = styled(Flex)`
  position: absolute;
  top: 70px;
  width: 100%;
  flex-direction: column;
  align-items: center;
`

export const QuestDetailLayer = styled(Flex)<{ focusOnGame: boolean }>`
  position: absolute;
  width: 100%;
  min-height: calc(100% - 340px);
  max-height: 125%;
  top: 345px;
  flex-direction: column;
  border-radius: 18px 18px 0 0;
  overflow: hidden;

  transition: top 500ms, min-height 500ms, max-height 500ms;
  ${({ focusOnGame }) =>
    focusOnGame &&
    `
    top: 100%;
    min-height: 0%;
    max-height: 0%;
  `}
`
